// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__23Jpd","content":"LoadingAlert_content__200YP"};